import zipcelx from 'zipcelx';
import XLSX from 'xlsx';
import moment from 'moment';
import moment2 from 'moment-timezone';
import jwt_decode from 'jwt-decode';
import { cloneDeep } from 'lodash';

export const formatNumberWithCommas = (num) => {
	console.log('numpy', num);
	if (num === undefined) return '';
    return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const parseFloatString = (str) => {
	// Removes $ and commas from strings representing float values
	let num = 0;
	if (str) {
		if (typeof str === 'string') {
			num = parseFloat(str.replace('$','').replace('%','').replace(/,/g, ''))
		} else if (typeof str === 'number') {
			num = str;
		}
	}
	return num;
}

// Makes sure that string doesnt contain a $ or comma
export const parseFloot = (str) => {
	let num = 0;
	if (str) {
		if (typeof str === 'string') {
			num = parseFloat(str.replace('$','').replace(/,/g, ''))
		} else if (typeof str === 'number') {
			num = str;
		}
	}
	return num;
}

export const updateObject = (oldObject, updatedProperties) => {
	return {
		...oldObject,
		...updatedProperties,
	};
};

export const commatize = (x, decimals) => {
	let v = x;
	if (!Boolean(parseFloat(x))) v = 0;
	if (decimals) {
		if (!v) return '0.00';
		v = parseFloat(v).toFixed(2);
		v = Number(v).toLocaleString('en', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
		return v;
	}

	if (typeof x !== 'string') {
		if (x === 0) {
			return '0';
		}
		return x ? x.toLocaleString() : '';
	}

	x = x.replace(/,/g, '');

	x = parseFloat(x).toLocaleString();

	return x;
};

export const numberWithCommas = (x) => {
	if (x) {
		if (!isNaN(x)) {
			var y = Number(parseFloat(x).toFixed(10));
			var parts = y.toString().split('.');
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			return parts.join('.');
		}
		//return xx; //parseFloat(xx).toFixed(10).replace(/0+$/, "");
	}
	return x;
};

export const convertToFixed = (num) => {
	if (num) {
		if (!isNaN(num)) {
			return Number(num).toFixed(5);
		}
	}
	return num;
};

export const convertToFixed3 = (num) => {
	if (num) {
		if (!isNaN(num)) {
			return Number(num).toFixed(3);
		}
	}
	return num;
};

export const nameSort = (a, b) => {
	if (a.name < b.name) return -1;
	if (a.name > b.name) return 1;
	return 0;
};

export const checkValidity = (value, rules) => {
	let isValid = true;
	if (rules) {
		if (rules.required) {
			isValid = value.trim() !== '' && isValid;
		}
		if (rules.minLength) {
			isValid = value.length >= rules.minLength && isValid;
		}
		if (rules.maxLength) {
			isValid = value.length <= rules.maxLength && isValid;
		}
		if (rules.isEmail) {
			const pattern =
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

			isValid = pattern.test(value) && isValid;
		}
		if (rules.isNumeric) {
			const pattern = /^\d+$/;
			isValid = pattern.test(value) && isValid;
		}
	}
	return isValid;
};

export const upperCase = (word) => {
	if (word) {
		return word.toUpperCase();
	}
	return word;
};

export const convert = (date) => {
	const darr = date.split('/');
	const y = darr[2];
	const m = darr[0];
	const d = darr[1];
	return `${y}-${m}-${d}`;
};

export const formatTime = (date) => {
	return '';
};

// has UTC
export const formatDate2 = (date, date_type) => {
	if (date_type === 'is_parse_zone') {
		return moment.parseZone(date).utc().format('MM/DD/YYYY');
	}
	return moment(date).utc().format('MM/DD/YYYY');
};

export const formatDate3 = (date, date_type) => {
	if (date_type === 'is_parse_zone') {
		return moment.parseZone(date).format('MM/DD/YYYY h:mma');
	}
	const mom = moment(date).format('MM/DD/YYYY h:mma');
	return mom;
};

// NO UTC
export const formatDate4 = (date, date_type) => {
	if (date_type === 'is_parse_zone') {
		return moment.parseZone(date).format('MM/DD/YYYY');
	}
	return moment(date).format('MM/DD/YYYY');
};

export const formatTime2 = (date, date_type) => {
	if (!date) return '';
	if (date_type === 'is_parse_zone') {
		const d = moment.parseZone(date).format('hh:mm a');
		let darr = d.split(' ');
		darr[1] = darr[1].toUpperCase();
		const newd = darr.join(' ');
		return newd;
	} else if (date_type === 'no_utc') {
		const d = moment(date).format('hh:mm a');
		let darr = d.split(' ');
		darr[1] = darr[1].toUpperCase();
		const newd = darr.join(' ');
		return newd;
	} else {
		const d = moment(date).utc().format('hh:mm a');
		let darr = d.split(' ');
		darr[1] = darr[1].toUpperCase();
		const newd = darr.join(' ');
		return newd;
	}
};

export const getDayDiffs = (date1, date2, logger) => {
	const a = date1;
	const b = date2;
	if (!moment.isMoment(a) || !moment.isMoment(b)) return null;
	const days_different = a.diff(b, 'days') + 1;
	if (logger) {
		console.log('logging', a.format('MM/DD/YYYY'), b.format('MM/DD/YYYY'));
	}
	return days_different;
};

export const getDateDiffs = (date1, date2) => {
	const a = moment(date1);
	const b = moment(date2);
	b.add(1, 'days');
	var years = a.diff(b, 'year');
	b.add(years, 'years');

	const noOfDaysInb = b.daysInMonth();
	const noOfDaysIna = a.daysInMonth();
	let months = 0;
	if (noOfDaysInb > noOfDaysIna) {
		months = b.diff(a, 'months');
		a.add(months, 'months');
	} else {
		months = a.diff(b, 'months');
		b.add(months, 'months');
	}
	var days = a.diff(b, 'days');
	return {
		years: Math.abs(years),
		months: Math.abs(months),
		days: Math.abs(days),
	};
};

export const getDateDiffs2 = (date1, date2) => {
	const a = moment(date1, 'MM/DD/YYYY');
	const b = moment(date2, 'MM/DD/YYYY');
	b.add(1, 'days');

	var years = a.diff(b, 'year');
	b.add(years, 'years');

	var months = a.diff(b, 'months');
	b.add(months, 'months');

	var days = a.diff(b, 'days');
	return {
		years: Math.abs(years),
		months: Math.abs(months),
		days: Math.abs(days),
	};

	// b.add(1, 'days');
	// var years = a.diff(b, 'year');
	// b.add(years, 'years');

	// const noOfDaysInb = b.daysInMonth();
	// const noOfDaysIna = a.daysInMonth();
	// let months = 0;
	// if (noOfDaysInb > noOfDaysIna) {
	//     months = b.diff(a, "months");
	//     a.add(months, "months");
	// } else {
	//     months = a.diff(b, 'months');
	//     b.add(months, 'months');
	// }
	// var days = a.diff(b, 'days');
	// return {
	//     years: Math.abs(years),
	//     months: Math.abs(months),
	//     days: Math.abs(days),
	// }
};

export const getDateDiffs3 = (date1, date2) => {};

export const getNumberOfDaysBetween = (date1, date2) => {
	let num = 0;
	if (date1 && date2) {
		const mom_date1 = moment(date1, 'MM/DD/YYYY', true);
		const mom_date2 = moment(date2, 'MM/DD/YYYY', true);
		if (mom_date1.isValid() && mom_date2.isValid()) {
			num = mom_date2.diff(mom_date1, 'days')+1;
		}
	}
	return num;
}

export const getTimestamp = (date) => {
	return moment(date).unix();
};

export const convertToTimestamp = (date) => {
	if (!date) return null;
	const arr = date.split('/');
	return new Date(`${arr[2]}-${arr[0]}-${arr[1]}`).getTime();
};

export const convertToTimestamp2 = (date) => {
	if (!date) return null;
	const arr = date.split('/');
	return moment(`${arr[2]}-${arr[0]}-${arr[1]}`).unix();
};

export const convertUnixToDate = (unix) => {
	if (!unix) return null;
	return moment.unix(unix).format('MM/DD/YYYY');
};

export const convertToUnix = (date) => {
	if (!date) return null;
	const arr = date.split('/');
	return moment(`${arr[2]}-${arr[0]}-${arr[1]}`).unix();
};

export const convertTime12to24 = (time12h) => {
	const [time, modifier] = time12h.split(' ');

	let [hours, minutes] = time.split(':');

	if (hours === '12') {
		hours = '00';
	}

	if (modifier === 'PM') {
		hours = parseInt(hours, 10) + 12;
	}

	return `${hours}:${minutes}`;
};

export const formatDateForBackend = (date, time) => {
	if (!date) return '';
	const date_arr = date.split('/');
	if (!time) return `${date_arr[2]}-${date_arr[0]}-${date_arr[1]} 00:00:00`;
	if (time) {
		const time24 = convertTime12to24(time);
		return `${date_arr[2]}-${date_arr[0]}-${date_arr[1]} ${time24}:00`;
	}
};

export const formatDate = (date, timeStatus) => {
	var d = new Date(date),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = '0' + month;
	if (day.length < 2) day = '0' + day;

	let finalFormat = [month, day, year].join('/');
	if (timeStatus) {
		const h = d.getHours(),
			m = d.getMinutes(),
			s = d.getSeconds();
		const time = `${h}:${m}:${s}`;
		finalFormat = [month, day, year].join('/') + ' ' + time;
	}
	return finalFormat;
};

export const getParameterByName = (name, url) => {
	if (!url) url = window.location.href;
	name = name.replace(/[[]/, '[').replace(/[\]]/, ']');
	var regexS = '[\\?&]' + name + '=([^&#]*)';
	var regex = new RegExp(regexS);
	var results = regex.exec(url);
	return results == null ? null : results[1];
};

export const normalizePhone = (value) => {
	var cleaned = ('' + value).replace(/[^A-Za-z0-9]/g, '');
	// var cleaned = ('' + value).replace(/\D/g, '')
	var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
	if (match) {
		var intlCode = match[1] ? '+1' : '';
		return [intlCode, '(', match[2], ')', match[3], '-', match[4]].join('');
	}
	return value;
};

export const denormalizePhone = (value) => {
	if (value) {
		// value = value.match(/\d/g);
		// if (value) {
		//   value = value.join("");
		// } else {
		//   value = '';
		// }
		if (typeof value === 'string') {
			return value.replace(/[)( -+-]/g, '');
		}
	}
	return value; // replace all leading non-digits with nothing
};

export const generateCSV = (data, file_name) => {
	// Building the CSV from the Data two-dimensional array
	// Each column is separated by ";" and new line "\n" for next row
	var csvContent = '';
	data.forEach(function (infoArray, index) {
		let dataString = infoArray.join(';');
		csvContent += index < data.length ? dataString + '\n' : dataString;
	});

	// The download function takes a CSV string, the filename and mimeType as parameters
	// Scroll/look down at the bottom of this snippet to see how download is called
	var download = function (content, fileName, mimeType) {
		var a = document.createElement('a');
		mimeType = mimeType || 'application/octet-stream';

		if (navigator.msSaveBlob) {
			// IE10
			navigator.msSaveBlob(
				new Blob([content], {
					type: mimeType,
				}),
				fileName
			);
		} else if (URL && 'download' in a) {
			//html5 A[download]
			a.href = URL.createObjectURL(
				new Blob([content], {
					type: mimeType,
				})
			);
			a.setAttribute('download', fileName);
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
		} else {
			window.location.href =
				'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
		}
	};

	download(csvContent, file_name);
};

export const generateExcel = (data, filename) => {
	if (data.data) {
		let arr = [];
		data.data.forEach((d) => {
			arr.push([
				{
					value: d[0],
					type: 'string',
				},
				{
					value: d[1],
					type: 'string',
				},
				{
					value: d[2],
					type: 'string',
				},
				{
					value: d[3],
					type: 'string',
				},
				{
					value: d[4],
					type: 'string',
				},
				{
					value: d[5],
					type: 'string',
				},
			]);
		});

		const config = {
			filename: filename,
			sheet: {
				data: arr,
			},
		};

		zipcelx(config);
	}
};

export const generateExcel2 = (data, filename) => {
	let worksheet = XLSX.utils.aoa_to_sheet(data.data);
	worksheet['!cols'] = data.cols;
	let new_workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(new_workbook, worksheet, 'sheet');
	XLSX.writeFile(new_workbook, filename);
};

export const qs = (queryString) => {
	var query = {};
	var pairs = (
		queryString[0] === '?' ? queryString.substr(1) : queryString
	).split('&');
	for (var i = 0; i < pairs.length; i++) {
		var pair = pairs[i].split('=');
		query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
	}
	return query;
};

export const checkForDuplicates = (arr) => {
	return arr.reduce(
		(acc, v, i, arr) =>
			arr.indexOf(v) !== i && acc.indexOf(v) === -1 ? acc.concat(v) : acc,
		[]
	);
};

export const convertDateStr = (dateStr) => {
	if (!dateStr) {
		return -1;
	}
	const months = {
		JAN: '01',
		FEB: '02',
		MAR: '03',
		APR: '04',
		MAY: '05',
		JUN: '06',
		JUL: '07',
		AUG: '08',
		SEP: '09',
		OCT: '10',
		NOV: '11',
		DEC: '12',
	};

	const da = dateStr.split(' ');
	const month = months[da[0].toUpperCase()];
	const date = `${da[2]}-${month}-${da[1]}`;

	const d = new Date(date);
	return d.getTime();
};

export const checkDateOrder = (start, end) => {
	const startTime = convertDateStr(start),
		endTime = convertDateStr(end);
	if (startTime > endTime) {
		return false;
	}
	return true;
};

// used for Meeting and Showing
export const checkDateOrder2 = (args) => {
	const {
		start_date,
		start_time,
		end_date,
		end_time
	} = args;
	const start = formatDateForBackend(
		start_date,
		start_time
	);
	const end = formatDateForBackend(
		end_date,
		end_time
	);
	const startTime = moment(start).unix(),
		endTime = moment(end).unix();
	if (startTime > endTime || startTime === endTime) {
		return false;
	}
	return true;
};

export const isValidDate = (str) => {
	return moment(str, 'MMM DD YYYY', true).isValid();
};

export const isValidDate2 = (str) => {
	return moment(str, 'MM/DD/YYYY', true).isValid();
};

export const dateRangeOverlaps = (
	startDateA,
	endDateA,
	startDateB,
	endDateB
) => {
	if (endDateA < startDateB || startDateA > endDateB) {
		return null;
	}

	var obj = {};
	obj.startDate = startDateA <= startDateB ? startDateB : startDateA;
	obj.endDate = endDateA <= endDateB ? endDateA : endDateB;

	return obj;
};

export const cleanAllPhones = (bpo) => {
	const bp = { ...bpo };
	if (bp.gen_tel) {
		bp.gen_tel = denormalizePhone(bp.gen_tel);
	}
	if (bp.gen_fax) {
		bp.gen_fax = denormalizePhone(bp.gen_fax);
	}
	['tel', 'alttel', 'mobile', 'fax'].forEach((field) => {
		if (bp[`accounts_payable_${field}`]) {
			bp[`accounts_payable_${field}`] = denormalizePhone(
				bp[`accounts_payable_${field}`]
			);
		}
		if (bp[`purchasing_${field}`]) {
			bp[`purchasing_${field}`] = denormalizePhone(
				bp[`accounts_payable_${field}`]
			);
		}
	});

	if (bp.additionalContacts) {
		if (bp.additionalContacts.length > 0) {
			bp.additionalContacts.forEach((ac, i, bpp) => {
				['tel', 'alttel', 'mobile', 'fax'].forEach((field) => {
					if (bpp[i][field]) {
						bpp[i][field] = denormalizePhone(bpp[i][field]);
					}
				});
			});
		}
	}

	return bp;
};

export const swapKeyValues = (json) => {
	var ret = {};
	for (var key in json) {
		ret[json[key]] = key;
	}
	return ret;
};

export const arraysEqual = (_arr1, _arr2) => {
	if (
		!Array.isArray(_arr1) ||
		!Array.isArray(_arr2) ||
		_arr1.length !== _arr2.length
	)
		return false;

	var arr1 = _arr1.concat().sort();
	var arr2 = _arr2.concat().sort();

	for (var i = 0; i < arr1.length; i++) {
		if (arr1[i] !== arr2[i]) return false;
	}
	return true;
};

export const dynamicSort = (property) => {
	var sortOrder = 1;
	if (property[0] === '-') {
		sortOrder = -1;
		property = property.substr(1);
	}
	return function (a, b) {
		/* next line works with strings and numbers,
		 * and you may want to customize it to your needs
		 */
		var result =
			a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
		return result * sortOrder;
	};
};

export const dateToday = () => {
	const today = moment(new Date()).format('MMM DD YYYY'),
		oneYear = moment(new Date()).add('years', 1).format('MMM DD YYYY');

	return [today.toUpperCase(), oneYear.toUpperCase()];
};

// check if number is between 0.00001 and 100,000
export const checkMinMax = (num, decimals, allowZero) => {
	if (!isNaN(num)) {
		const parsed = parseFloat(num);
		if (parsed === 0) {
			if (!allowZero) {
				return false;
			} else {
				return true;
			}
		}

		if (decimals === 5) {
			if (parsed >= 0.00001 && parsed <= 100000) {
				return true;
			}
		}

		if (decimals === 3) {
			if (parsed >= 0.001 && parsed <= 100000) {
				return true;
			}
		}
	}
	return false;
};

export const getUsername = () => {
	const token = localStorage.getItem('token');
	let username = '';
	if (token) {
		const decoded = jwt_decode(token);
		username = decoded.name;
	}
	return username;
};

export const filterByDate = (arr, field, startD, endD) => {
	let startDate = null,
		endDate = null;
	if (startD) {
		// const startArr = startD.split('/');
		//startDate = new Date(startArr[2], parseInt(startArr[0])-1, startArr[1], 0);
		startDate = moment(startD, 'MM-DD-YYYY hh:mm a').valueOf();
	}
	if (endD) {
		// const endArr = endD.split('/');
		//endDate = new Date(endArr[2], parseInt(endArr[0])-1, endArr[1], 24);
		endDate = moment(endD, 'MM-DD-YYYY hh:mm a').valueOf();
	}

	if (startDate && endDate) {
		if (startDate > endDate || startDate === endDate) {
			return null;
		}
	}

	return arr.filter((obj) => {
		const d = new Date(obj[field]).getTime();
		if (startDate && !endDate) {
			return d > startDate;
		} else if (!startDate && endDate) {
			return d < endDate;
		} else if (startDate && endDate) {
			return d > startDate && d < endDate;
		} else {
			return true;
		}
	});
};

export const renameToTPP = (str) => {
	return str.replace(/GMP/g, 'TPP');
};

export const capitalize = (string) => {
	return string.charAt(0).toUpperCase() + string.slice(1);
};

export const capitalizeAll = (str) => {
	if (!str) return str;
	const arr = str.split(' ');
	let newarr = [];
	arr.forEach((a) => {
		newarr.push(capitalize(a));
	});
	return newarr.join(' ');
};

export const removeWhitespace = (obj) => {
	if (!obj) return obj;
	const newObj = { ...obj };
	Object.keys(obj).forEach((field) => {
		newObj[field] = obj[field]
			? typeof obj[field] === 'string'
				? obj[field].trim()
				: obj[field]
			: obj[field];
	});
	return newObj;
};

export const clone = (obj) => {
	if (!obj) return null;
	try {
		const newObj = JSON.parse(JSON.stringify(obj));
		return newObj;
	} catch(e) {
		console.error('clone failed:', e, obj);
		return {};
	}
	return null;
	// return cloneDeep(obj);
};

export const base64toBlob = (base64Data, contentType = '') => {
	const sliceSize = 1024;
	const byteCharacters = atob(base64Data);
	const bytesLength = byteCharacters.length;
	const slicesCount = Math.ceil(bytesLength / sliceSize);
	const byteArrays = new Array(slicesCount);

	for (let sliceIndex = 0; sliceIndex < slicesCount; sliceIndex += 1) {
		const begin = sliceIndex * sliceSize;
		const end = Math.min(begin + sliceSize, bytesLength);

		const bytes = new Array(end - begin);
		for (let offset = begin, i = 0; offset < end; i += 1, offset += 1) {
			bytes[i] = byteCharacters[offset].charCodeAt(0);
		}

		byteArrays[sliceIndex] = new Uint8Array(bytes);
	}

	return new Blob(byteArrays, { type: contentType });
};

export const toBase64 = (u8) => {
	return btoa(String.fromCharCode.apply(null, u8));
};

export const formatCurrencyUSD = (num) => {
	return new Intl.NumberFormat('en-US', {
		currency: 'usd',
		style: 'currency',
	}).format(num);
};

export const formatInteger = (num) => {
	return new Intl.NumberFormat('en-US').format();
};

export const isValidEmail = (email) => {
	return /^\S+@\S+\.\S+$/.test(email);
};

export const addDashes = (fvalue) => {
	if (!fvalue) return '';
	let f_val = fvalue.replace(/\D[^\.]/g, '');
	fvalue = f_val.slice(0, 3) + '-' + f_val.slice(3, 6) + '-' + f_val.slice(6);
	return fvalue;
};

export const updateTheObj = (prevObj, newValues) => {
	if (prevObj) {
		const newObj = clone(prevObj);
		if (newValues) {
			if (typeof newValues === 'object') {
				const arr = Object.keys(newValues);
				for (let i = 0; i < arr.length; i++) {
					const field = arr[i];
					newObj[field] = newValues[field];
				}
			}
		}
		return newObj;
	}
	return prevObj;
};

export const financial = (x) => {
	return Number.parseFloat(x).toFixed(2);
};

export const timestampToDate = (timestamp) => {
	let date = '';
	if (timestamp) {
		date = moment(timestamp).format('MM/DD/YYYY');
	}
	return date;
};

export const get2DecimalRound = (num) => {
	if (num) {
		return Math.round(parseFloat(num) * 100) / 100;
	}
	return 0;
};

export const validateDatesAndRange = (
	date1,
	date2,
	minRangeTimestamp,
	maxRangeTimestamp
) => {
	if (!moment(date1, 'MM/DD/YYYY', true).isValid() || !moment(date2, 'MM/DD/YYYY', true).isValid()) {
		return false;
	}

	const date1_timestamp = convertToUnix(date1);
	const date2_timestamp = convertToUnix(date2);
	if (date1_timestamp > date2_timestamp) {
		return false;
	}

	if (minRangeTimestamp && maxRangeTimestamp) {
		if (date1_timestamp < minRangeTimestamp || date2_timestamp > maxRangeTimestamp) {
			return false;
		}
	}

	return true;
};

export const validateDates = (
	date1,
	date2,
	minRangeTimestamp,
	maxRangeTimestamp
) => {
	if (!date1 || !date2) return false;

	const valid_date1 = moment(date1, 'MM/DD/YYYY', true).isValid();
	const valid_date2 = moment(date1, 'MM/DD/YYYY', true).isValid();
	if (!valid_date1 || !valid_date2) return false;

	const date1_timestamp = convertToUnix(date1);
	const date2_timestamp = convertToUnix(date2);
	if (date1_timestamp >= date2_timestamp) return false;

	return true;
};

export const validateRange = (
	date1,
	date2,
	minRangeTimestamp,
	maxRangeTimestamp
) => {
	if (!date1 || !date2) return false;

	const valid_date1 = moment(date1, 'MM/DD/YYYY', true).isValid();
	const valid_date2 = moment(date1, 'MM/DD/YYYY', true).isValid();
	if (!valid_date1 || !valid_date2) return false;

	const date1_timestamp = convertToUnix(date1);
	const date2_timestamp = convertToUnix(date2);
	if (minRangeTimestamp && maxRangeTimestamp) {
		if (date1_timestamp < minRangeTimestamp) return false;
		if (date2_timestamp > maxRangeTimestamp) return false;
	}

	return true;
};

export const formatDollar = (value, parentheses = false, negative = false) => {
	let v = value ? parseFloat(value) : 0;
	if (!Boolean(parseFloat(value))) {
		v = 0;
	}

	if (negative) {
		v = -Math.abs(v);
	}

	if (parentheses && v < 0) {
		v = Math.abs(v);
	}

	let currency = v.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
	});

	if (parentheses && value < 0) {
		currency = `(${currency})`;
	}

	return currency;
};

export const generateMonthArray = (num) => {
	const monthArray = [];
	for (let i = 1; i <= num; i++) {
		monthArray.push('Month ' + i);
	}
	return monthArray;
};

export const generateDayArray = (num = 30) => {
	const dayArray = [];
	for (let i = 1; i <= num; i++) {
		dayArray.push('Day ' + i);
	}
	return dayArray;
};

export const currencyToNumber = (currencyString) => {
	if (!currencyString) return 0;
	if (typeof currencyString === 'number') return currencyString;
	const strippedString = currencyString.replace(/\$|,/g, '');
	const number = parseFloat(strippedString);
	return number;
};

// ****************
// * PDF UTILITIES
// ****************
export const printPdf = (buffer) => {
	const pdfBlob = new Blob([new Uint8Array(buffer)], {
		type: 'application/pdf',
	});
	let pdfFrame = document.body.appendChild(document.createElement('iframe'));
	pdfFrame.style.display = 'none';
	pdfFrame.onload = () => void pdfFrame.contentWindow.print();
	pdfFrame.src = window.URL.createObjectURL(pdfBlob);
};

export const downloadPDF = (pdfData, filename) => {
	const url = window.URL.createObjectURL(
		new Blob([new Uint8Array(pdfData).buffer])
	);
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', filename);
	document.body.appendChild(link);
	link.click();
};

export const isNumeric = (value) => {
	return /^-?\d+$/.test(value);
};

// 1 -> Primary
// 2 -> Secondary
// 3 -> Third
// 4 -> Fourth
// ...
export const ordinalInWord = (cardinal, usePrimary = false) => {
	if (usePrimary && cardinal === 1) return 'primary';
	if (usePrimary && cardinal === 2) return 'secondary';

	var ordinals = [
		'zeroth',
		'first',
		'second',
		'third',
		'fourth',
		'fifth',
		'sixth',
		'seventh',
		'eighth',
		'ninth',
		'tenth',
		'eleventh',
		'twelfth',
		'thirteenth',
		'fourteenth',
		'fifteenth',
		'sixteenth',
		'seventeenth',
		'eighteenth',
		'nineteenth',
		'twentieth',
	];
	var tens = {
		20: 'twenty',
		30: 'thirty',
		40: 'forty' /* and so on */,
	};
	var ordinalTens = {
		30: 'thirtieth',
		40: 'fortieth',
		50: 'fiftieth',
	};

	if (cardinal <= 20) {
		return ordinals[cardinal];
	}

	if (cardinal % 10 === 0) {
		return ordinalTens[cardinal];
	}

	return tens[cardinal - (cardinal % 10)] + ordinals[cardinal % 10];
};

export const createAddress = (c) => {
	let range1_1 = '';
	let range1_2 = '';
	let range2_1 = '';
	let range2_2 = '';
	if (c.address_is_range) {
		if (c.address_is_range === 'Yes') {
			range1_1 = c.street_range1 ? c.street_range1 : '';
			range1_2 = c.street_range2 ? c.street_range2 : '';
		}
	}
	if (c.address2_is_range) {
		if (c.address2_is_range === 'Yes') {
			range2_1 = c.street2_range1 ? c.street2_range1 : '';
			range2_2 = c.street2_range2 ? c.street2_range2 : '';
		}
	}
	const range1 = range1_1 && range1_2 ? `${range1_1}-${range1_2}` : '';
	const range2 = range2_1 && range2_2 ? `${range2_1}-${range2_2}` : '';
	return `${range1} ${c.street1 ? c.street1 : ''}, ${range2} ${
		c.street2 ? c.street2 : ''
	} ${c.city ? c.city : ''}, ${c.state ? c.state : ''} ${c.zip ? c.zip : ''}`;
};

export const createPremisesAddress = (c) => {
	let range1_1 = '';
	let range1_2 = '';
	let range2_1 = '';
	let range2_2 = '';
	if (c.address_is_range) {
		if (c.address_is_range === 'Yes') {
			range1_1 = c.street_range1 ? c.street_range1 : '';
			range1_2 = c.street_range2 ? c.street_range2 : '';
		}
	}
	if (c.address2_is_range) {
		if (c.address2_is_range === 'Yes') {
			range2_1 = c.street2_range1 ? c.street2_range1 : '';
			range2_2 = c.street2_range2 ? c.street2_range2 : '';
		}
	}
	const range1 = range1_1 && range1_2 ? `${range1_1}-${range1_2}` : '';
	const range2 = range2_1 && range2_2 ? `${range2_1}-${range2_2}` : '';
	return `${range1} ${c.street1 ? c.street1 : ''}, ${range2} ${
		c.street2 ? c.street2 : ''
	}`;
};

export function getInitialSubFieldsData(
	subFieldsChild,
	subFieldArrays = ['outside_broker', 'referral_firm']
) {
	const initialData = {};

	Object.keys(subFieldsChild).forEach((field) => {
		if (subFieldArrays.indexOf(field) !== -1) {
			initialData[field] = [];
		} else {
			initialData[field] = '';
		}
	});

	return initialData;
}

export const getInitialData = (
	fields,
	arrayTypes = [
		'multi-contact-agent',
		'multi-dates',
		'referral_firm',
		'lease_term_ranges',
		'payment_schedule',
		'lessees',
		'lessors',
		'lessee_pre_splits',
		'lessor_pre_splits',
		'outside_brokers',
		'referral_firm',
		'multi-contact',
		'object_array',
		'spaces',
	],
	defaults = {
		date: moment().format('MM/DD/YYYY'),
		lessee_referral_firm_fee_amount_choice: 'Value',
		referral_firm_fee_amount_choice: 'Value',
	}
) => {
	const initialDat = {};

	Object.keys(fields).forEach((field) => {
		if (arrayTypes.indexOf(fields[field].type) !== -1) {
			initialDat[field] = [];
		} else if (defaults.hasOwnProperty(field)) {
			initialDat[field] = defaults[field];
		} else {
			initialDat[field] = '';
		}
		if (field === 'commission_based_off') {
			initialDat[field] = 'Actual Days';
		}
	});

	return initialDat;
};

export const reformatGoogleTime = (date) => {
	let new_date = '';
	if (date) {
		new_date = date.replace('T', ' ');
		let new_date_arr = new_date.split(' ');
		let new_time = '00:00:00';
		if (new_date_arr[1]) {
			new_time = new_date_arr[1].split('-')[0];
		}
		new_date = new_date_arr[0] + ' ' + new_time;
	}
	return new_date;
}

export const us_states_abbreviations = [{"name":"Alabama","abbreviation":"AL"},{"name":"Alaska","abbreviation":"AK"},{"name":"Arizona","abbreviation":"AZ"},{"name":"Arkansas","abbreviation":"AR"},{"name":"California","abbreviation":"CA"},{"name":"Colorado","abbreviation":"CO"},{"name":"Connecticut","abbreviation":"CT"},{"name":"Delaware","abbreviation":"DE"},{"name":"Florida","abbreviation":"FL"},{"name":"Georgia","abbreviation":"GA"},{"name":"Hawaii","abbreviation":"HI"},{"name":"Idaho","abbreviation":"ID"},{"name":"Illinois","abbreviation":"IL"},{"name":"Indiana","abbreviation":"IN"},{"name":"Iowa","abbreviation":"IA"},{"name":"Kansas","abbreviation":"KS"},{"name":"Kentucky","abbreviation":"KY"},{"name":"Louisiana","abbreviation":"LA"},{"name":"Maine","abbreviation":"ME"},{"name":"Maryland","abbreviation":"MD"},{"name":"Massachusetts","abbreviation":"MA"},{"name":"Michigan","abbreviation":"MI"},{"name":"Minnesota","abbreviation":"MN"},{"name":"Mississippi","abbreviation":"MS"},{"name":"Missouri","abbreviation":"MO"},{"name":"Montana","abbreviation":"MT"},{"name":"Nebraska","abbreviation":"NE"},{"name":"Nevada","abbreviation":"NV"},{"name":"New Hampshire","abbreviation":"NH"},{"name":"New Jersey","abbreviation":"NJ"},{"name":"New Mexico","abbreviation":"NM"},{"name":"New York","abbreviation":"NY"},{"name":"North Carolina","abbreviation":"NC"},{"name":"North Dakota","abbreviation":"ND"},{"name":"Ohio","abbreviation":"OH"},{"name":"Oklahoma","abbreviation":"OK"},{"name":"Oregon","abbreviation":"OR"},{"name":"Pennsylvania","abbreviation":"PA"},{"name":"Rhode Island","abbreviation":"RI"},{"name":"South Carolina","abbreviation":"SC"},{"name":"South Dakota","abbreviation":"SD"},{"name":"Tennessee","abbreviation":"TN"},{"name":"Texas","abbreviation":"TX"},{"name":"Utah","abbreviation":"UT"},{"name":"Vermont","abbreviation":"VT"},{"name":"Virginia","abbreviation":"VA"},{"name":"Washington","abbreviation":"WA"},{"name":"West Virginia","abbreviation":"WV"},{"name":"Wisconsin","abbreviation":"WI"},{"name":"Wyoming","abbreviation":"WY"}];

export const exists = (val) => {
    if (val === 0 || val) {
        if (val !== undefined || val !== null) return true;
    }
    return false;
}

// makes sure that undefined or NaN is not displayed
export const chk = (str) => {
	if (str) {
		if (typeof str === 'string') return str;
		if (typeof str === 'number') return `${str}`;
	}
	if (str === 0) {
		return '0';
	}
	return '';
}

export const date2unix = (date) => {
    return moment(date, 'MM/DD/YYYY', true).unix();
}

export const round2dec = (num) => {
	if (!num) return 0;
    return Math.round(num * 100) / 100;
}

export const isImage = (filename) => {
	console.log('filename check', filename);
  const ext = filename.split('.').pop().toLowerCase();
  return ['jpg', 'jpeg', 'png', 'webp', 'gif', 'heic', 'avif'].includes(ext);
}

export const round2dec2 = (value) => {
  if (value === null || value === undefined || value === 0) {
    return 0;
  }

  // Standard 2-decimal rounding first
  const rounded = Math.round((value + Number.EPSILON) * 100) / 100;

  const decimal = rounded - Math.floor(rounded);

  // If decimal part is between .97 and .99 → round to whole number
  if (decimal >= 0.97) {
    return Math.round(rounded);
  }

  // Otherwise return normally, with 2 decimals if needed
  return Number.isInteger(rounded) ? rounded : rounded.toFixed(2);
};


export const toTwoSep = v =>
  Number.isFinite(+v)
    ? new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(+v)
    : '';

export const getMonth = (date, originalStringNeeded) => {
    let month = !originalStringNeeded ? 0 : '';
    if (date) {
        const date_arr = date.split('/');
        const month_str = date_arr[0];
        if (month_str) {
            if (originalStringNeeded) {
                month = month_str;
            } else {
                month = parseInt(month_str);
            }
        }
    }
    return month;
}

export const getDay = (date, originalStringNeeded) => {
    let day = !originalStringNeeded ? 0 : '';
    if (date) {
        const date_arr = date.split('/');
        const day_str = date_arr[1];
        if (day_str) {
            if (originalStringNeeded) {
                day = day_str;
            } else {
                day = parseInt(day_str);
            }
        }
    }
    return day;
}

export const getYear = (date, originalStringNeeded) => {
    let year = !originalStringNeeded ? 0 : '';
    if (date) {
        const date_arr = date.split('/');
        const year_str = date_arr[2];
        if (year_str) {
            if (originalStringNeeded) {
                year = year_str;
            } else {
                year = parseInt(year_str);
            }
        }
    }
    return year;
}

export const getDaysInRangeInAMonth = (date1, date2) => {
    const day1 = getDay(date1);
    const day2 = getDay(date2);
    return (day2 - day1) + 1
}

// makes sure that month is MM
export const formatDoubleDigits = (num) => {
    let month_str = '';
    if (num) {
        if (typeof num !== 'string') {
            if (num < 10) {
                return `0${num}`;
            } else {
                return `${num}`;
            }
        } else {
            if (num.length === 1) {
                return `0${num}`;
            } else {
                month_str = num;
            }
        }
    }
    return month_str;
}

export const round = (value, precision) => {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

// ------------------------------------------
// USED FOR ESTIMATED DAYS IN A 30 DAY MONTH
// ------------------------------------------
export const calculateDays = (month_str, day_str, isAlreadyInteger) => {
    if (!month_str || !day_str) return 0;
    const month = isAlreadyInteger ? month_str : parseInt(month_str.split(' ')[1]);
    const day = isAlreadyInteger ? day_str : parseInt(day_str.split(' ')[1]);
    return ((month - 1) * 30) + day;
}

export const calculateDaysEstimated = (str) => {
	try {
		const arr = str.split('Day ');
		const month_str = arr[0] ? arr[0].split('Month ')[1].trim() : '0';
		const day_str = arr[1].trim();
		console.log('calculating est', str, month_str, day_str);
		if (!month_str || !day_str) return 0;
		const month = parseInt(month_str);
		const day = parseInt(day_str);
		return ((month - 1) * 30) + day;
	} catch(e) {
		return 0;
	}
}

const getMonthDay = (str) => {
	const arr = str.split('Day ');
	const month = arr[0] ? arr[0].split('Month ')[1].trim() : '0';
	const day = arr[1].trim();
	return {
		month,
		day
	}
}

export const getMonthEstimate = (str) => {
	const arr = str.split('Day ');
	return arr[0];
}

export const checkIfFullMonth = (s1, s2) => {
	const o1 = getMonthDay(s1);
	const o2 = getMonthDay(s2);
	if (o1.day && o2.day) {
		if (o1.day == 1 && o2.day == 30) {
			return true;
		}
	}
	return false;
}

export const checkIfFullYear = (s1, s2) => {
	const o1 = calculateDaysEstimated(s1);
	const o2 = calculateDaysEstimated(s2);
	if (o1 && o2) {
		if ((o2 - o1 + 1) === 360) {
			return true;
		} 
	}
	return false;
}

export const reverseCalculateDays = (int, returnString) => {
	console.log('reverseCalculating', int, returnString);
	if (!int) return null;
	let a = Math.trunc(int / 30); // month
	let b = int % 30; // days
	if (b === 0) {
		b = 30;
	}
	if (b !== 30) {
		a++;
	}
	const month = `Month ${a}`;
	const day = `Day ${b}`;
	if (returnString) {
		return `${month} ${day}`;
	}
	return {
		month,
		day
	}
}

export const calculateYearCompleteness = (ranges, year_index, data, is_estimated) => {
	// calculates Esimated year's completeness
	if (data.lease_length) {
		if (!isNaN(data.lease_length)) {
			let days = 0;
			ranges.forEach(range => {
				const range_days1 = calculateDays(range.month1, range.day1);
				const range_days2 = calculateDays(range.month2, range.day2);
				const rangedays = range_days2 - range_days1 + 1;
				days = days + rangedays;
			})

			const lease_length = parseInt(data.lease_length);
			const years = lease_length / 12;
			if (years > 1) {
				// more than a year
				let arr = [];
				const years_str = years.toString();
				const int_year = years_str.split('.')[0];
				const dec_year = years_str.split('.')[1];
				for (let i = 1; i < (parseInt(int_year) + 1); i++) {
					arr.push(360);
				}
				if (dec_year) {
					const days_in_this_year = Math.round(parseFloat('.'+dec_year) * 12) * 30;
					arr.push(days_in_this_year);
				}
				if (days !== arr[year_index]) {
					return false;
				}
			} else {
				// less than or equal to a year
				if (days !== (lease_length * 30)) return false;
			}
		}
	}
	return true;
}

export const sortMonthsRange = ( a, b ) => {
    if (a.month2 && a.day2 && b.month2 && b.day2) {
        const a_month2 = parseInt(a.month2.split(' ')[1]);
        const a_day2 = parseInt(a.day2.split(' ')[1]);
        const a_days = ((a_month2 - 1) * 30) + a_day2;

        const b_month2 = parseInt(b.month2.split(' ')[1]);
        const b_day2 = parseInt(b.day2.split(' ')[1]);
        const b_days = ((b_month2 - 1) * 30) + b_day2;

        if ( a_days < b_days) {
        	return -1;
        }
        if ( a_days > b_days) {
        	return 1;
        }
    }
    return 0;
}

export const sortDaysRange = (a, b) => {
	const a_days = a.start;
	const b_days = b.start;
	if ( a_days < b_days) {
		return -1;
	}
	if ( a_days > b_days) {
		return 1;
	}
	return 0;
}

export const inRange = (x, min, max) => {
    return ((x-min)*(x-max) <= 0);
}

export const cloneJ = (obj) => {
	if (!obj) return obj;
	return JSON.parse(JSON.stringify(obj));
}

export const getContactAddress = (contactObj, typeOfAddress) => {
	let address = {};
	if (contactObj) {
		if (contactObj.addresses) {
			contactObj.addresses.forEach(a => {
				if (!typeOfAddress) {
					if (a.type === 'M') {
						address = a;
					}
				} else {
					if (a.type === typeOfAddress) {
						address = a;
					}
				}
			})
		}
	}
	return address;
}

export const checkForChanges = (initialData, newData) => {
	let changed = false;
	if (initialData && newData) {
		const dataFields = Object.keys(initialData);
		for (let i = 0; i < dataFields.length; i++) {
			const field = dataFields[i];
			if (field === 'submitted_by_name') continue;
			if (field === 'date') continue;
			const initial_data = initialData[field] ? JSON.stringify(initialData[field]) : '';
			const new_data = newData[field] ? JSON.stringify(newData[field]) : '';
			if (initial_data !== new_data) {
				console.log('this changed', initial_data, new_data, field)
				changed = true;
				break;
			}
		}
	}
	return changed;
}

export const getCompanyDBAData = (dba_id, dba_arr) => {
	if (!dba_id || !dba_arr) {
		return null;
	}
	let found = null;
	for (let i = 0; i < dba_arr.length; i++) {
		const dba = dba_arr[i];
		if (dba.id === dba_id) {
			found = dba;
			break;
		}
	}
	return found;
}

export const extractContactAddress = (contact) => {
	const obj = {
		address1: '',
		address2: '',
		city: '',
		state: '',
		zip: ''
	};
	if (contact.addresses) {
		contact.addresses.forEach(cad => {
			if (cad.type === 'M') {
				obj.address1 = cad.street1;
				obj.address2 = cad.street2;
				obj.city = cad.city;
				obj.state = cad.state;
				obj.zip = cad.zip;
			}
		})
	}
	return obj;
}

export const theVal = (val) => {
	if (val === null || val === undefined || val === false) {
		return '';
	} else {
		if (typeof val === 'string') {
			return val.trim();
		}
	}
	return val;
}

export const makeid = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}

export const createObjName = (obj) => {
	let company = theVal(obj.company_name);
	let name = `${company} ${theVal(obj.first_name)} ${theVal(obj.last_name)} ${theVal(obj.dba_name)}`;
	return name;
}

export const twoDecimals = (val) => {
	let str = '0.00';
	if (val) {
		if (typeof val === 'number') {
			console.log('sstr1', str, val);
			str = val.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2});
		}
	}
	console.log('sstr2', str);
	return str;
}

export const handleError = (err) => {
	console.log('err - ', err);
	if (err.response) {
		if (err.response.data) {
			console.log('err', err.response.data);
		}
	}
}

export const alphabet = 'abcdefghijklmnopqrstuvwxyz'.toUpperCase().split('');

export const formatTimestamp = (date, format = 'MM/DD/YYYY h:mm a') => {
	return moment(date).subtract('hours', 7).format(format)
}

export const createTheContactName = (chosen) => {
	let name = '';
	if (chosen.first_name && chosen.last_name) {
		name = `${chosen.first_name} ${chosen.last_name}`;
	}
	console.log('name', name)
	return name;
}

export const handleScrollToTop = (elem) => {
	console.log('scroll ->', elem)
	if (elem) {
		if (elem.current) {
			console.log('ref scroll');
			elem.current.scrollIntoView({
				behavior: "smooth", // Adds smooth scrolling
				block: "start",     // Scroll to the top of the element
				inline: "nearest"   // Adjust horizontal alignment if needed
			});
		}
	}
};

export const getFileExtension = (filename) => {
  return filename.split('.').pop();
}

export const uniqueBy = (arr, field) => {
	const seen = new Set();
	return arr.filter(item => {
		const name = item[field];
		if (seen.has(name)) return false;
		seen.add(name);
		return true;
	});
};

export const formatUTCtoPST = (utcString) => {
  return moment2.utc(utcString)
    .tz('America/Los_Angeles')
    .format('MM/DD/YYYY hh:mm A'); // Adjust format as needed
}

export const downloadFile = (res) => {
    const contentDisposition = res.headers['content-disposition'];
    const fileNameArr = contentDisposition.split(';')[1].split('=')[1].split('"');
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileNameArr[1]}`);
    document.body.appendChild(link);
    link.click();
}

export const formatDateOnly = (date) => {
    let newDate = '';
    if (date) {
        const date_arr = date.split('T');
        if (date_arr[0]) {
            const arr = date_arr[0].split('-');
            newDate = `${arr[1]}/${arr[2]}/${arr[0]}`;
        }
    }
    return newDate;
}

const format2 = n =>
  Number.isFinite(n)
    ? n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : '';

export const formatPercentage = (val) => {
	const valnum = parseFloatString(val);
	return `${format2(valnum)}%`;
}

export const getMonthDifference2 = (startDate, endDate) => {
    const start = moment(startDate, 'MM/DD/YYYY', true);
    const end = moment(endDate, 'MM/DD/YYYY', true);

    if (!start.isValid() || !end.isValid() || !end.isAfter(start)) {
        return null;
    }

    const diffInMonths = end.diff(start, 'months', true);
    const isStartOfMonth = start.date() === 1;
    const isEndOfMonth = end.date() === end.daysInMonth();

    // If it's a perfect whole-month span (start on 1st, end on last day)
    if (isStartOfMonth && isEndOfMonth) {
        return Math.round(diffInMonths);
    }

    // Otherwise, show 1 decimal
    return parseFloat(diffInMonths.toFixed(1));
};

export const getTotalMonthsDecimal = (months, days, daysPerMonth = 30) => {
  const total = (months ? parseInt(months) : 0) + ((days ? parseInt(days) : 0) / daysPerMonth);
  return Number(total.toFixed(1));
}

export const parseInt2 = value => {
	console.log('parseint2', value);
  const str = String(value).trim();
  const num = parseInt(str, 10);
  return Number.isNaN(num) || str.toLowerCase() === "nan" ? 0 : num;
};

export const swap = (arr, i, j) => {
  const temp = arr[i];
  arr[i] = arr[j];
  arr[j] = temp;
}

export const vconsole = {
  enabled: false,

  log: (...args) => {
    if (!vconsole.enabled) return;
    console.log(...args);
  },

  warn: (...args) => {
    if (!vconsole.enabled) return;
    console.warn(...args);
  },

  error: (...args) => {
    if (!vconsole.enabled) return;
    console.error(...args);
  },
};

export const moveLeft = (arr, index) => {
  if (index === 0) return arr;  // can't move left
  const newArr = [...arr];
  swap(newArr, index, index - 1);
  return newArr;
}

export const moveRight = (arr, index) => {
  if (index === arr.length - 1) return arr; // can't move right
  const newArr = [...arr];
  swap(newArr, index, index + 1);
  return newArr;
}

export const formatLabel = (str) => {
  return str
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
}

export const getPropertyPrefix = (property_is) => {
    let prefix = '';
    const name = property_is;
    if (name === 'Property Management') {
        prefix = `9`;
    } else if (name === 'No Listing') {
        prefix = `NL`;
    } else if (name === 'Tenant Rep') {
        prefix = `TR`;
    } else if (name === 'Consulting') {
        prefix = `C`;
    } else if (name === 'Prospective Listing') {
        prefix = ``;
    } else if (name === 'Referral') {
        prefix = `R`;
    } else if (name === 'Buyer Represented') {
        prefix = ``;
    } 
    return prefix;
}


